
// Reference

var ENDPOINT_GET_STATE  = 'get';
var ENDPOINT_MODIFY     = 'modify';
var ENDPOINT_REMOVE     = 'remove';
var ENDPOINT_POSTAGE    = 'postage'


// Helpers

function apiEndpoint (path) {
  return '/cart/' + path;
}

function formatCents (value) {
  return '$' + value.toFixed(2);
}

function __numberInput (value) {
  return (
    '<div data-widget="number-input">' +
      '<input data-number-value="" type="number" id="_qty" name="qty" value="' + value + '">' +
      '<div data-number-controls>' +
        '<button type="button" data-number-plus></button>' +
        '<button type="button" data-number-minus></button>' +
      '</div>' +
    '</div>');
}

function tableVersion__lineItem (item, ix) {
  return (
    '<tr data-line-item-ix="' + ix + '">' +
      '<td>' + item.name + '</td>' +
      '<td>' + __numberInput(item.qty) + '</td>' +
      '<td><button class="remove-item" type="button" data-remove="' + ix + '"></button></td>' +
      '<td>' + formatCents(item.price * item.qty) + '</td>' +
    '</tr>');
}

function __lineItem (item, ix) {
  return (
    '<div class="table-row line-item" data-line-item-ix="' + ix + '">' +
      '<span>' + item.name + '</span>' +
      '<span>' + __numberInput(item.qty) + '</span>' +
      '<span><button class="remove-item" type="button" data-remove="' + ix + '"></button></span>' +
      '<span>' + formatCents(item.price * item.qty) + '</span>' +
    '</div>');
}


//
// Ajax Cart
//
// Update session's cart and re-render the dom representation with updated values.
// Also, propagate errors in a useful way.
//

module.exports = function AjaxCart ($host, config) {

  // Dom
  var $itemContainer    = $('[data-ajax-cart-item-host]',     $host);
  var $outputTotal      = $('[data-cart-output-total]',       $host);
  var $outputPostage    = $('[data-cart-output-postage]',     $host);
  var $outputServiceFee = $('[data-cart-output-service-fee]', $host);
  var $outputSubtotal   = $('[data-cart-output-subtotal]',    $host);
  var $postageSelector  = $('[data-postage-selector]',        $host);

  // State
  var callbacks = { update: id };
  var state = { lastCart: null };

  // Functions
  function modifyLineItem (ix, qty) {
    log('modifyLineItem');
    updateCart(ENDPOINT_MODIFY, { item: ix, qty: qty });
  }

  function removeLineItem (ix) {
    updateCart(ENDPOINT_REMOVE, { item: ix });
  }

  function updateCart (path, data) {
    setBusy(true);

    $.ajax({
      url: apiEndpoint(path),
      type: 'get',
      data: data,
      dataType: 'json',
      error: function (err) {
        setBusy(false);
        showError(err.responseText);
      },
      success: function (response) {
        setBusy(false);
        if (response.is_error) {
          showError(response.reason);
        } else {
          render(response.value);
        }
      }
    });
  }

  function setBusy (mode) {
    $itemContainer.css('opacity', mode ? 0.5 : 1.0);
  }

  function findAndAdjustQuantity ($button) {
    var $lineItem = $button.parents('[data-line-item-ix]');
    var $widget   = $lineItem.find('[data-widget="number-input"]');
    var $input    = $widget.find('[data-number-value]');
    modifyLineItem($lineItem.data('line-item-ix'), $input.val());
  }

  function handlePostageSelection () {
    updateCart('postage', { state: getPostageSelection() });
  }

  function appendLineItem ($item) {
    $itemContainer.prepend($item);
  }

  function getPostageSelection () {
    var value = null;
    $postageSelector.each(function () { if (this.checked) value = this.value; });
    return value;
  }

  function showError (errorMessage) {
    render(state.lastCart);
    console.warn(errorMessage);
    alert(errorMessage);
  }

  function render (cartState) {
    log('AjaxCart::render -', cartState);
    state.lastCart = cartState;

    $itemContainer.find('[data-line-item-ix]').remove();
    cartState.items.map(__lineItem).reverse().map(appendLineItem);

    $outputTotal.text(formatCents(cartState.total * (1 + config.serviceFeePercent/100)));
    $outputPostage.text(formatCents(cartState.postage));
    $outputSubtotal.text(formatCents(cartState.subtotal));
    $outputServiceFee.text(formatCents(cartState.total * config.serviceFeePercent/100));

    initAllWidgetsWithin($itemContainer);
    callbacks.update(cartState);
  }

  // Listeners
  $itemContainer.on('click',  '[data-remove]',       function () { removeLineItem(this.dataset.remove); });
  $itemContainer.on('change', '[data-number-value]', function () { findAndAdjustQuantity($(this)); });
  $postageSelector.on('change', handlePostageSelection);

  // Init
  updateCart('get', {});

  // Interface
  return {
    onCartUpdate: function (λ) { callbacks.update = λ }
  };

}

